import React, { ReactNode, useId } from 'react';
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import classNames from 'classnames';
import { Icon } from '../icon/icon';
import { Typography } from '../typography/typography';
import { FormInlineNotification, InlineNotification } from '../form-inline-notification/form-inline-notification';
import { notNil } from '../../core/helpers/is-nil';
import styles from './checkbox.module.scss';

type Props = {
  children: string | ReactNode;
  checked?: boolean;
  disabled?: boolean;
  focused?: boolean;
  onChange?: (checked: boolean) => void;
  inlineNotification?: InlineNotification;
};

export const Checkbox: React.FC<Props> = ({ children, checked, disabled, focused, inlineNotification, onChange }) => {
  const checkboxId = useId();

  const hasInlineNotification = notNil(inlineNotification);
  const hasError = notNil(inlineNotification) && inlineNotification.type === 'error';

  return (
    <div className={styles.root}>
      <div className={classNames(styles.checkboxContainer, { [styles.focused]: focused })}>
        <RadixCheckbox.Root
          aria-invalid={hasError}
          checked={checked}
          className={styles.checkbox}
          disabled={disabled}
          id={checkboxId}
          onCheckedChange={onChange}
        >
          <RadixCheckbox.Indicator>
            <Icon className={styles.icon} size="16" variant="check" />
          </RadixCheckbox.Indicator>
        </RadixCheckbox.Root>
        <label className={styles.label} htmlFor={checkboxId}>
          <Typography tag="span" variant="maintext">
            {children}
          </Typography>
        </label>
      </div>
      {hasInlineNotification ? (
        <FormInlineNotification type={inlineNotification.type}>{inlineNotification.message}</FormInlineNotification>
      ) : null}
    </div>
  );
};
